import * as _ from 'underscore';
import { UpdateSiteLogoFormSpecs } from '../../siteLogo/forms/UpdateSiteLogoForm';
import { ActiveDirectorySyncSectionSpecs } from './sections/ActiveDirectorySyncSection';
import { AskDataSectionSpecs } from './sections/AskDataSection';
import { AutomaticAccessSectionSpecs } from './sections/AutomaticAccessSection';
import { AutoSuspendExtractRefreshSectionSpecs } from './sections/AutoSuspendExtractRefreshSection';
import { CacheWarmupSectionSpecs } from './sections/CacheWarmupSection';
import { CatalogingSectionSpecs } from './sections/CatalogingSection';
import { CollectionsSectionSpecs } from './sections/CollectionsSection';
import { CommentingSettingSectionSpecs } from './sections/CommentingSettingSection';
import { CrossDataBaseJoinsSectionSpecs } from './sections/CrossDataBaseJoinsSection';
import { DataAccelerationSpecs } from './sections/data-acceleration/DataAccelerationSection';
import { DataAlertsSectionSpecs } from './sections/DataAlertsSection';
import { EmailSettingsSpecs } from './sections/EmailSettingsSection';
import { ExtractEncryptionSectionSpecs } from './sections/ExtractEncryptionSection';
import { GuestAccessSpecs } from './sections/GuestAccessSection';
import { ManageUsersSectionSpecs } from './sections/manage-users-section/ManageUsersSection';
import { ManagedKeychainCleanupSectionSpecs } from './sections/ManagedKeychainCleanup';
import { MetricsContentTypeSpecs } from './sections/MetricsContentTypeSection';
import { MobileSectionSpecs } from './sections/MobileSection';
import { NotificationFlowRunsSpecs } from './sections/NotificationsFlowRunsSection';
import { NotifySiteAdminsOnThrottleSpec } from './sections/NotifySiteAdminsOnThrottleSection';
import { OAuthClientsRegistrySectionSpecs } from './sections/oauth-clients-registry/OAuthClientsRegistry';
import { PerformanceMetricsSectionSpecs } from './sections/PerformanceMetricsSection';
import { PersonalSpaceSectionSpecs } from './sections/personal-space-section/PersonalSpaceSection';
import { PrepConductorSpecs } from './sections/PrepConductorSection';
import { RequestAccessSectionSpecs } from './sections/RequestAccessSection';
import { RevisionHistorySectionSpecs } from './sections/revision-history/RevisionHistorySection';
import { RunNowSpec } from './sections/RunNowSection';
import { SensitiveLineageDataSectionSpecs } from './sections/SensitiveLineageDataSection';
import { SharingSectionSpecs } from './sections/SharingSection';
import { SiteNameAndIdSpecs } from './sections/site-name-and-id/SiteNameAndIdSection';
import { SiteAvailabilitySpecs } from './sections/SiteAvailabilitySection';
import { SiteInviteNotificationSpecs } from './sections/SiteInviteNotificationSection';
import { SiteTimeZoneSectionSpecs } from './sections/SiteTimeZoneSection';
import { StartPageSpec } from './sections/StartPageSection';
import { StorageSectionSpecs } from './sections/storage/StorageSection';
import { SubscriptionsSpec } from './sections/SubscriptionsSection';
import { SupportAccessSectionSpecs } from './sections/SupportAccessSection';
import { UserNotificationsSiteSettingsSectionSpecs } from './sections/UserNotificationsSiteSettingsSection';
import { UserVisibilitySpecs } from './sections/UserVisibilitySection';
import { VizRecommendationsSectionSpecs } from './sections/VizRecommendationsSection';
import { WebAuthoringSpecs } from './sections/WebAuthoringSection';
import { WebPageObjectsSectionSpecs } from './sections/WebPageObjectsSection';
import { ComponentSpecs } from './SettingsComponentRegistryFunctions';

export function createComponentRegistry(...specArray: ComponentSpecs<any>[]) {
  const result: _.Dictionary<ComponentSpecs<any>> = {};
  specArray.forEach(spec => result[spec.name] = spec);
  return result;
}

/**
 * All react-based sections in the settings page should be added to this object to allow them to be named in
 * the pug file while migrating, and to dynamically load them later on
 */
export const SettingsComponentRegistry = createComponentRegistry(
  CrossDataBaseJoinsSectionSpecs,
  SupportAccessSectionSpecs,
  CollectionsSectionSpecs,
  CommentingSettingSectionSpecs,
  RequestAccessSectionSpecs,
  DataAlertsSectionSpecs,
  VizRecommendationsSectionSpecs,
  SharingSectionSpecs,
  WebPageObjectsSectionSpecs,
  AutomaticAccessSectionSpecs,
  SiteNameAndIdSpecs,
  SiteAvailabilitySpecs,
  PrepConductorSpecs,
  WebAuthoringSpecs,
  StorageSectionSpecs,
  RevisionHistorySectionSpecs,
  ManageUsersSectionSpecs,
  GuestAccessSpecs,
  PerformanceMetricsSectionSpecs,
  CatalogingSectionSpecs,
  CacheWarmupSectionSpecs,
  ManagedKeychainCleanupSectionSpecs,
  AutoSuspendExtractRefreshSectionSpecs,
  EmailSettingsSpecs,
  DataAccelerationSpecs,
  SiteInviteNotificationSpecs,
  UserVisibilitySpecs,
  StartPageSpec,
  PersonalSpaceSectionSpecs,
  SubscriptionsSpec,
  NotificationFlowRunsSpecs,
  MobileSectionSpecs,
  NotifySiteAdminsOnThrottleSpec,
  AskDataSectionSpecs,
  MetricsContentTypeSpecs,
  SensitiveLineageDataSectionSpecs,
  RunNowSpec,
  ExtractEncryptionSectionSpecs,
  UserNotificationsSiteSettingsSectionSpecs,
  OAuthClientsRegistrySectionSpecs,
  ActiveDirectorySyncSectionSpecs,
  SiteTimeZoneSectionSpecs,
  UpdateSiteLogoFormSpecs,
);

